/**
 * © [2023] Conduent, Inc. All rights reserved. Conduent®and Conduent Agile
 * Star®are trademarks of Conduent, Inc. and/or its subsidiaries in the United
 * States and/or other countries.
 */
import React from 'react';
import * as Styles from '../../../../SharedModules/StyleConstant/StyleConstant';
import {
  amountComparator,
  cellRenderer,
} from '../../../../SharedModules/utilities/utilities';

export const TotalDollersPaidTableHeads = [
  {
    headerName: 'Check Number',
    field: 'checkNumber',
    editable: false,
    suppressMenu: false,
    sortable: true,
    minWidth: Styles.Width_125,

    cellStyle: { borderRightColor: Styles.BorderColor },
    wrapText: true,
    autoHeight: true,
    custClass: 'tbill-rate-editable-input',
    filter: 'agTextColumnFilter',
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
  },
  {
    headerName: 'Deposit Date',
    field: 'depositDate',
    editable: false,
    suppressMenu: false,
    sortable: true,
    minWidth: Styles.Width_130,

    cellStyle: { borderRightColor: Styles.BorderColor },
    wrapText: true,
    autoHeight: true,
    custClass: 'tbill-rate-editable-input',
    filter: 'agTextColumnFilter',
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
  },
  {
    headerName: 'Check Amount',
    field: 'checkAmount',
    editable: false,
    suppressMenu: false,
    sortable: true,
    minWidth: Styles.Width_130,
    isTextColorRed: true,
    printPrefixValue: '$',
    comparator: amountComparator,

    cellRenderer,

    cellStyle: { borderRightColor: Styles.BorderColor, textAlign: 'right' },
    wrapText: true,
    autoHeight: true,
    custClass: 'tbill-rate-editable-input',

    filter: 'agTextColumnFilter',
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
  },
  {
    headerName: 'Labeler ID',
    field: 'labelerCode',
    editable: false,
    suppressMenu: false,
    sortable: true,
    minWidth: Styles.Width_120,

    cellRenderer: 'GenericCodeTextBox',

    cellStyle: { borderRightColor: Styles.BorderColor },
    wrapText: true,
    autoHeight: true,
    custClass: 'tbill-rate-editable-input',
    filter: 'agTextColumnFilter',
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
  },
  {
    headerName: 'Batch ID',
    field: 'batchId',
    editable: false,
    suppressMenu: false,
    sortable: true,
    minWidth: Styles.Width_150,

    cellRenderer: 'GenericCodeTextBox',

    cellStyle: { borderRightColor: Styles.BorderColor },
    wrapText: true,
    autoHeight: true,
    custClass: 'tbill-rate-editable-input',
    filter: 'agTextColumnFilter',
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
  },
  {
    headerName: 'Receipt Number',
    field: 'receiptNumber',
    editable: false,
    suppressMenu: false,
    sortable: true,
    minWidth: Styles.Width_220,
    comparator: amountComparator,

    cellStyle: { borderRightColor: Styles.BorderColor },
    wrapText: true,
    autoHeight: true,
    custClass: 'tbill-rate-editable-input',
    filter: 'agTextColumnFilter',
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
  },
  {
    headerName: 'Allocated Amount',
    field: 'allocatedAmt',
    editable: false,
    suppressMenu: false,
    sortable: true,
    minWidth: Styles.Width_138,
    isTextColorRed: true,
    printPrefixValue: '$',
    comparator: amountComparator,
    cellRenderer,

    cellStyle: { borderRightColor: Styles.BorderColor, textAlign: 'right' },
    wrapText: true,
    autoHeight: true,
    custClass: 'tbill-rate-editable-input',
    filter: 'agTextColumnFilter',
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
  },
  {
    headerName: 'Unallocated Balance',
    field: 'unallocatedBalance',
    editable: false,
    suppressMenu: false,
    sortable: true,
    minWidth: Styles.Width_150,

    cellStyle: { borderRightColor: Styles.BorderColor },
    wrapText: true,
    autoHeight: true,
    custClass: 'tbill-rate-editable-input',
    filter: 'agTextColumnFilter',
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
  },
  {
    headerName: 'Status',
    field: 'statusCd',
    editable: false,
    suppressMenu: false,
    sortable: true,
    minWidth: Styles.Width_110,

    cellStyle: { borderRightColor: Styles.BorderColor },
    wrapText: true,
    autoHeight: true,
    custClass: 'tbill-rate-editable-input',
    filter: 'agTextColumnFilter',
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
  },
  {
    headerName: 'Program',
    field: 'program',
    editable: false,
    suppressMenu: false,
    sortable: true,
    minWidth: Styles.Width_130,

    cellStyle: { borderRightColor: Styles.BorderColor },
    wrapText: true,
    autoHeight: true,
    custClass: 'tbill-rate-editable-input',
    filter: 'agTextColumnFilter',
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
  },
];
